module.exports = __webpack_public_path__ + "static/media/cube3D.e4783bfb.mp4";